<template>
  <div class="home-banner">
    <md-swiper
      ref="swiper"
      :autoplay="3000"
      :is-prevent="false"
      :has-dots="false"
    >
      <md-swiper-item
        v-for="(item, index) in bannerList"
        :key="index"
        @click.native="switchRoute(item.routeName)"
      >
        <img :src="item.image" class="banner-item">
      </md-swiper-item>
    </md-swiper>
    <div class="invest-list" v-if="!$config.needElectronicContract && investList.length">
      <div class="invest-list-swiper">
        <md-swiper
          ref="investListSwiper"
          :autoplay="3000"
          :is-prevent="false"
          :has-dots="false"
          :default-index="1"
          :dragable="false"
          transition="slideY"
        >
          <md-swiper-item
            v-for="(item, index) in investList"
            :key="index"
          >
            <div class="invest-swiper-item">
              <img class="icon-horn" src="@/assets/image/icons/icon-horn.png">
              <div class="congratulation">{{ $t('congratulation') }}</div>
              <div class="invest-item">
                {{ formatInvestRecord(item) }}
              </div>
            </div>
          </md-swiper-item>
        </md-swiper>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperItem } from 'mand-mobile'

export default {
  i18n: {
    messages: {
      en: {
        slogan: 'Funding With Intelligence, Earn Measurable Profits.',
        sloganTip: 'Registered with and Monitored by',
        congratulation: 'Congratulations!',
        recordInfo: '{name} successfully fund {amount} {minutes} mins ago',
      },
      id: {
        slogan: 'Pinjamkan uang dengan pendanaan cermat, dapatkan keuntungan berlipat',
        sloganTip: 'Terdaftar dan diawasi oleh',
        congratulation: 'Selamat!',
        recordInfo: '{name} berhasil mendanai {amount} {minutes} menit lalu',
      },
    },
  },
  components: {
    [Swiper.name]: Swiper,
    [SwiperItem.name]: SwiperItem,
  },
  data() {
    const locale = this.$store.state.locale
    return {
      bannerList: [
        { image: require(`@/assets/image/home/banner/banner-default-${locale}.png`), routeName: '' },
        { image: require(`@/assets/image/home/banner/banner-invite-${locale}.png`), routeName: 'InviteFriend' },
        // { image: require(`@/assets/image/home/banner/banner-newyear-${locale}.png`), routeName: 'NewYear' },
        { image: require('@/assets/image/home/banner/banner-ojk.png'), routeName: 'OJK' },
      ],
      investList: [],
    }
  },
  computed: {
    locale() {
      return this.$store.state.locale
    },
  },
  mounted() {
    this.getInvestList()
  },
  methods: {
    async getInvestList() {
      try {
        const response = await this.$http.get('/order/list/last-hour')
        const data = response.data.data
        this.investList = data || []
      } catch (error) {
        console.log(error)
      }
    },
    formatInvestRecord(item) {
      return this.$t('recordInfo', {
        name: item.mobile,
        amount: this.$options.filters.formatMoney(item.amount),
        minutes: Math.ceil((Date.now() - item.createTimestamp) / 60000),
      })
    },
    switchRoute(routeName) {
      if (routeName) {
        this.$router.push({ name: routeName })
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.home-banner {
  position: relative;
  overflow: hidden;
}

.banner-item {
  width: 100%;
  display: block;
  cursor: pointer;
}

.invest-list {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding-left: 20px;
  height: 30px;
  background: rgba(16, 16, 16, 0.7);
  .invest-list-swiper /deep/ {
    height: 30px;
    .invest-swiper-item {
      height: 30px;
      overflow: hidden;
      font-size: 8px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .icon-horn {
        width: 10px;
        height: 10px;
        margin-right: 6px;
      }
      .congratulation {
        color: #FFCB00;
        font-size: 8px;
        font-weight: bold;
        margin-right: 5px;
      }
      .invest-item {
        color: #F8E71C;
      }
    }
  }
}

</style>
